import type { ComponentProps } from "react"
import * as VisuallyHidden from "@radix-ui/react-visually-hidden"
import { DialogTitle as DialogTitleBase } from "@/v2-ui/dialog/base/DialogBase"
import cn from "@/v2-ui/utils/utils.cn"
import ConditionalWrapper from "@/v2-ui/ConditionalWrapper"

export type DialogTitleProps = ComponentProps<typeof DialogTitleBase> & {
  isVisuallyHidden?: boolean
}

function DialogTitle(props: DialogTitleProps) {
  const { isVisuallyHidden, className, ...dialogTitleBaseProps } = props
  return (
    <ConditionalWrapper
      condition={isVisuallyHidden}
      renderWrapper={(children) => (
        <VisuallyHidden.Root>{children}</VisuallyHidden.Root>
      )}
    >
      <DialogTitleBase
        className={cn("ui-dialog-title", className)}
        {...dialogTitleBaseProps}
      />
    </ConditionalWrapper>
  )
}

export default DialogTitle
